/**
 * External Dependencies
 */
import React from 'react';
import classNames from 'classnames';
import { get } from 'lodash';

import { IconContext } from 'react-icons';
import * as fa from 'react-icons/fa';
import * as fi from 'react-icons/fi';
import * as md from 'react-icons/md';
import * as ri from 'react-icons/ri';
import * as bs from 'react-icons/bs';
import * as io from "react-icons/io";
import * as gr from 'react-icons/gr';
import * as ti from 'react-icons/ti';
import * as vsc from 'react-icons/vsc';
import * as bi from 'react-icons/bi';
import * as si from 'react-icons/si';

/**
 * Style dependencies
 */
import './styles.scss';


const icons = {
	...fa,
	...fi,
	...md,
	...ri,
	...bs,
	...io,
	...gr,
	...ti,
	...vsc,
	...bi,
	...si
};

/**
 * Internal Dependencies
 */

const Icon = ({ name, className, style, width, marginRight, ...rest }) => {
	const IconComponent = get(icons, [name], null);
	return IconComponent ? (
		<IconContext.Provider value={{ style: { verticalAlign: 'middle', marginRight: marginRight, width, ...style }, className: classNames('icon', className) }}>
			<IconComponent {...rest} />
		</IconContext.Provider>
	) : null;
};

Icon.defaultProps = {
	type: 'fi',
	name: 'cantfindme',
};

export default Icon;
